import {
    DateUtilities,
    JsonNotificationIdentifierModel,
    NotificationIdentifierModel,
    NotificationIdentifierModelFromJson,
} from '@evorait/pace-core';
import moment from 'moment';

export class MileageModel {
    public constructor(
        public notificationIdentifier: NotificationIdentifierModel,
        public distance: string,
        public startPlace: string,
        public endPlace: string,
        public recordedDate: moment.Moment,
    ) {}

    public get travelTime(): number {
        const hundred = 100;
        return parseInt(this.distance, 10) / hundred;
    }

    public get formattedDisplayedDate(): string {
        return DateUtilities.formatDate(this.recordedDate);
    }
}
export class MileageHistoryModelFromJson extends MileageModel {
    public constructor(data: JsonMileageHistoryModel) {
        const recordedDate = data.recordedDate ? moment(data.recordedDate) : moment.invalid();
        super(
            new NotificationIdentifierModelFromJson(data.notificationIdentifier),
            data.distance,
            data.startPlace,
            data.endPlace,
            recordedDate,
        );
    }
}
export interface JsonMileageHistoryModel {
    notificationIdentifier: JsonNotificationIdentifierModel;
    distance: string;
    startPlace: string;
    endPlace: string;
    recordedDate: string;
}
